import { render } from "./select-base.vue?vue&type=template&id=fcc0814e&scoped=true"
import script from "./select-base.vue?vue&type=script&lang=js"
export * from "./select-base.vue?vue&type=script&lang=js"

import "./select-base.vue?vue&type=style&index=0&id=fcc0814e&lang=scss&scoped=true"

import exportComponent from "/Users/kgeek/KGEEK/PERSONNAL/REMA/traning_lists/csn/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcc0814e"]])

export default __exports__